import {
  Input,
  Component,
  Output,
  ViewChild,
  ContentChild,
  forwardRef,
  EventEmitter,
  AfterViewInit,
  Injectable,
  HostListener
} from "@angular/core";
import {
DecimalPipe
} from "@angular/common";
import { GridOptions, TabToNextCellParams, NavigateToNextCellParams } from "ag-grid/dist/lib/entities/gridOptions";
import { RowDataTransaction } from "ag-grid/dist/lib/rowModels/inMemory/inMemoryRowModel";
import { GridActionsComponent } from "./editors/actions/actionscomponent";
import { IXSModalComponent } from "../ixsmodal/ixsmodal.component";
import { Subscription } from "rxjs/Subscription";
import { NavModalComponent } from "../../core/component/NavModal.Component";
import {
  Enum,
  GridType,
  modalArgs,
  addRow,
  customButton,
  customButtonList,
  moodcustomList,
  customGridMenu,
  summaryConfig,
  Operator,
  filterBy,
  Condition
} from "../config";
import { MessageBoxComponent } from "../messagebox/messagebox.component";
import { ColDef, AnimateSlideCellRenderer, RowNode } from "ag-grid/main";
import { ToolbarEvent } from "../../core/events/toolbar.event";
import { AppConstants } from "../../app.constant";
import { List } from "linqts";
import { SyncValue } from "../../core/service/syncdata.service";
import * as _ from 'lodash';
import * as XLSX from 'xlsx';
import { GenEnum } from "../../shell/shared/general.enum";
import { ExcelService } from "../../shell/shared/excel.service";
import { param } from "jquery";

@Component({
  selector: "ixs-aggrid",
  templateUrl: "aggrid.component.html",
  styleUrls: ["ixs-grid-theme.css"],
  providers:[DecimalPipe]
})
export class AgGridComponent implements AfterViewInit {
  private gridColumnApi;
  toolbarEvent: ToolbarEvent;
  private searchvalue;
  filterenabled: Boolean = false;
  fieldshow: Boolean = false;
  buttondisabled: Boolean = true;
  firstpagecount: any = 1;
  lastpagecount: any = 1;
  columnTypes: any;
  columnApi: any;

  @Input()
  mode: number = Enum.Mode.Default;

  @Input()
  hideAdd: boolean;

  @Input()
  showClose: boolean = true;

  @Input()
  hideDelete: boolean;

  private _pagesize: string = "10";
  @Input()
  hideSerial: boolean = true;

  @Input()
  hideActionDelete: boolean = false;

  @Input()
  hideActionView: boolean = false;

  @Input()
  hideActionColumn: boolean = false;

  @Input()
  hideActionEdit: boolean = false;

  @Input()
  disableActionDelete: boolean = false;

  @Input()
  disableActionView: boolean = false;

  @Input()
  disableActionEdit: boolean = false;

  @Input()
  hideSelection: boolean = true;

  @Input()
  sort: boolean = false;

  @Input()
  tblButtonCaption: string = "New";

  @Input()
  newscreen: boolean;
   api: any;

  @Input()
  useaddmissionprocess: boolean;

  get _tblButtonCaption(): string {
    return this.tblButtonCaption;
  }
  set _tblButtonCaption(value: string) {
    this.tblButtonCaption = value;
  }

  @Input()
  name: string;
  get pageSize(): string {
    return this._pagesize;
  }

  @Input()
  set pageSize(value: string) {
    this._pagesize = value;

    // this.changePageSize();
  }

  @Input()
  pagination: boolean = false;
  

  @Input()
  filter: boolean = false;

  @Input()
  modalSize: string = Enum.modalSize.Large;
  constructor(private excel: ExcelService,private _decpipe:DecimalPipe) {
    this.toolbarEvent = AppConstants.injector.get(ToolbarEvent);


  }

  @Input()
  modaltype: number = Enum.modalType.Normal;

  @Input()
  modalwidth: any = Enum.modalSize.Large;

  ngAfterViewInit(): void {
    this.myscreen.screen = this.screen;
    this.Filtershow();
    if (this.options.api) {
      this.options.api.hideOverlay();
      this.options.enableFilter = this.enableFilter;
      this.options.suppressNoRowsOverlay = this.hideNoRecordOverlay;
      if (
        (this.data instanceof Array &&
          this.data &&
          this.data.length &&
          this.data.length === 0) ||
        !this.data
      )
        this.options.api.showNoRowsOverlay();
    }
    setTimeout(() => {
      this.changePageSize();
      this.setCount();
      if (this.options.api) {
        var cellDefs = this.options.api.getEditingCells();

        cellDefs.forEach(function (cellDef) {
          console.log(cellDef.rowIndex);
          console.log(cellDef.column.getId());
          console.log(cellDef.floating);
        });
      }
      // this.ColumnsWidth();
    }, 0);

    this.Groupload();
  }

  @Output()
  onRowClicked: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionOpen: EventEmitter<modalArgs> = new EventEmitter<modalArgs>();

  @Output()
  actionClose: EventEmitter<modalArgs> = new EventEmitter<modalArgs>();

  @Output()
  toolbarClick: EventEmitter<customButton> = new EventEmitter<customButton>();

  @Output()
  selectedRowClick: EventEmitter<object> = new EventEmitter<object>();

  @Input()
  showList: boolean = false;

  @Output()
  toolbarClickList: EventEmitter<customButtonList> = new EventEmitter<
    customButtonList
    >();

  @Input()
  customButtonList: any = [];
  customButtonListClick(item: customButtonList) {
    this.toolbarClickList.emit(item);
  }

  @ViewChild("agGrid")
  public agGrid: AgGridComponent;

  @Input()
  hideNoRecordOverlay: boolean = true;

  public _data: any;

  @Input()
  lvl: any;

  @ViewChild(forwardRef(() => IXSModalComponent)) myscreen: IXSModalComponent;
  @ContentChild("ngContent") private screen: NavModalComponent<any>;
  @ViewChild("SummaryModal") SummaryModal: IXSModalComponent;

  @Input()
  get data(): any {
    return this._data;
  }
  set data(data: any) {
    if (data && data.length && data.length > 0) {
      for (var index = 0; index < data.length; index++) {
        data[index].lineindex = index + 1;
      }
      this.generateIndex(0);
      if (this.pagination && this.options.api)
        this.options.api.paginationGoToFirstPage();
    }
    this._data = data;
    if (this._data && this._data.length && this._data.length > 0) {
      setTimeout(() => {
        this.changePageSize();
      }, 0);
    }
  }

  @Input()
  get selectedData(): any {
    return this.options.api.getSelectedRows();
  }
  set selectedData(data: any) { }

  public _columns: ColDef[];
  @Input()
  get columns(): any {
    return this._columns;
  }
  set columns(columns: any) {
    if (columns) {
      if (this.hideSerial) {
        if (!columns.filter(o => o.field === "lineindex")[0]) {
          columns.unshift({
            headerName: "S.No",
            field: "lineindex",
            width: 60,
            // filter: "false",
            headerClass: "Serialno-cell"
          });
        }
      }
      if (this.hideSelection) {
        if (
          this.type === GridType.selectionGrid ||
          this.type === GridType.inputGrid
        ) {
          if (!columns.filter(o => o.field === "selectedCol")[0]) {
            columns.unshift(this.selColumn);
          }
        }
      }
    }
    this._columns = columns;
    this.setCustomColumns();
    // setTimeout(() => {
    //   this.setCount();
    // }, 500);
  }





  private setCustomColumns() {

    if (this.columns) {
      if (this.type === GridType.actionsGrid && this.hideActionColumn === false) {
        if (!this.columns.filter(o => o.field === "actionid")[0]) {
          this.actionColumn["hideView"] = this.hideActionView;
          this.actionColumn["hideEdit"] = this.hideActionEdit;
          this.actionColumn["hideDelete"] = this.hideActionDelete;
          this.actionColumn["disableDelete"] = this.disableActionDelete;
          this.actionColumn["disableEdit"] = this.disableActionEdit;
          this.actionColumn["disableView"] = this.disableActionView;
          this.columns.push(this.actionColumn);
        }
      }
      this.columns.forEach(element => {
        if (element.field !== "selectedCol" && element.field !== "lineindex") {
          element["cellStyle"] = { padding: "0px", background: element.color };
        }

        if (element && element.cellEditorFramework && element.cellEditorFramework.name && element.cellEditorFramework.name === "GridPositiveIntEditorComponent") {
          element['cellClass'] = 'numeric-cell';
          
        if (element.type === GenEnum.numericformatter.currency) {

             
            element['valueFormatter'] = params =>  params.value == undefined ?  0 : Math.floor(params.value).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            
          }else{
           
          element['valueFormatter'] = params =>  params.value == undefined ?  0 : this._decpipe.transform(Math.floor(params.value).toString());
        }


          if (element.type === GenEnum.calculationtype.sum) {

            //this.calculation();
          }




        }
        if (element && element.cellEditorFramework && element.cellEditorFramework.name && element.cellEditorFramework.name === "GridNumericEditorComponent") {

          element['cellClass'] = 'numeric-cell';
          
        if (element.type === GenEnum.numericformatter.currency) {

             
            element['valueFormatter'] = params =>  params.value == undefined ?  0 : Math.floor(params.value).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            
          }else{
           
          element['valueFormatter'] = params =>  params.value == undefined ?  0 : Math.floor(params.value).toString();
        }


          if (element.type === GenEnum.calculationtype.sum) {

            //this.calculation();
          }




        }


      });
    }
  }

  _type: number = GridType.inputGrid;
  @Input()
  get type(): number {
    return this._type;
  }
  set type(type: number) {
    this._type = type;

    if (type === GridType.inputGrid) this.hideNoRecordOverlay = true;
    else this.hideNoRecordOverlay = false;

    if (type === GridType.actionsGrid && this.isExport === undefined) {
      this.isExport = true;
    } else {
      this.isExport = false;
    }

    this.setCustomColumns();
  }

  @Input()
  addRowAt = addRow.bottom;

  @Input()
  enableFilter: boolean;

  // clickshowFilter: Boolean = false;

  @Input()
  allowRowDraged: boolean = false;

  height = "313px";
  index: Number = 0;

  paginationPageSize: number = Number(this.pageSize);

  recordsvalue: any = [
    { key: 5, value: 5 },
    { key: 10, value: 10 },
    { key: 20, value: 20 },
    { key: 50, value: 50 },
    { key: 100, value: 100 }
  ];

  @ViewChild("recordselect") dropdown: HTMLSelectElement;

  async changePageSize() {
    if (this.pagination === true) {
      this.paginationPageSize = Number(this.pageSize);
      if (
        Number(this.pageSize) !== 5 &&
        Number(this.pageSize) !== 10 &&
        Number(this.pageSize) !== 20 &&
        Number(this.pageSize) !== 50 &&
        Number(this.pageSize) !== 100
      ) {
        this.height = 32 * Number(this.pageSize) + "px";

        if (this.dropdown !== undefined) {
          let array = [];
          array = this.dropdown.nativeElement.options;

          let obj = this.recordsvalue.filter(
            o => o.value === Number(this.pageSize)
          )[0];
          if (!obj) {
            let value = Number(this.pageSize);
            this.recordsvalue.push({ value: Number(value) });
            this.recordsvalue = new List<SyncValue>(this.recordsvalue)
              .OrderBy(o => o.value)
              .ToArray();
            return (this.dropdown.nativeElement.value = this.recordsvalue.filter(
              o => o.value === Number(this.pageSize)
            )[0]);
          } else {
            this.setCount();
            if (this.pagination && this.options.api) {
              this.options.api.paginationGoToFirstPage();
            }
            this.firstpage();
          }
        }
      } else {
        if (Number(this.pageSize) === 5) {
          this.height = 40 * Number(this.pageSize) + "px";
          this.setCount();
          if (this.pagination && this.options.api) {
            this.options.api.paginationGoToFirstPage();
          }
          this.firstpage();
        }
        if (Number(this.pageSize) === 10) {
          this.height = 35 * Number(this.pageSize) + "px";
          this.setCount();
          if (this.pagination && this.options.api) {
            this.options.api.paginationGoToFirstPage();
          }
          this.firstpage();
        }
        if (Number(this.pageSize) === 20) {
          this.height = 31.5 * Number(this.pageSize) + "px";
          this.setCount();
          if (this.pagination && this.options.api) {
            this.options.api.paginationGoToFirstPage();
          }
          this.firstpage();
        }
        if (Number(this.pageSize) === 50) {
          this.height = 29.3 * Number(this.pageSize) + "px";
          this.setCount();
          if (this.pagination && this.options.api) {
            this.options.api.paginationGoToFirstPage();
          }
          this.firstpage();
        }
        if (Number(this.pageSize) === 100) {
          this.height = 28.7 * Number(this.pageSize) + "px";
          this.setCount();
          if (this.pagination && this.options.api) {
            this.options.api.paginationGoToFirstPage();
          }
          this.firstpage();
        }
      }
    }
    if (this.options.floatingFilter === true) {
      if (
        Number(this.pageSize) !== 5 &&
        Number(this.pageSize) !== 10 &&
        Number(this.pageSize) !== 20 &&
        Number(this.pageSize) !== 50 &&
        Number(this.pageSize) !== 100
      ) {
        this.height = 34 * Number(this.pageSize) + "px";
      } else {
        if (Number(this.pageSize) === 5) {
          this.height = 47 * Number(this.pageSize) + "px";
          this.setCount();
          if (this.pagination && this.options.api) {
            this.options.api.paginationGoToFirstPage();
          }
          this.firstpage();
        }
        if (Number(this.pageSize) === 10) {
          this.height = 38 * Number(this.pageSize) + "px";
          this.setCount();
          if (this.pagination && this.options.api) {
            this.options.api.paginationGoToFirstPage();
          }
          this.firstpage();
        }
        if (Number(this.pageSize) === 20) {
          this.height = 33.5 * Number(this.pageSize) + "px";
          this.setCount();
          if (this.pagination && this.options.api) {
            this.options.api.paginationGoToFirstPage();
          }
          this.firstpage();
        }
        if (Number(this.pageSize) === 50) {
          this.height = 30.8 * Number(this.pageSize) + "px";
          this.setCount();
          if (this.pagination && this.options.api) {
            this.options.api.paginationGoToFirstPage();
          }
          this.firstpage();
        }
        if (Number(this.pageSize) === 100) {
          this.height = 29.9 * Number(this.pageSize) + "px";
          this.setCount();
          if (this.pagination && this.options.api) {
            this.options.api.paginationGoToFirstPage();
          }
          this.firstpage();
        }
      }
    } else if (
      this.pagination === false &&
      this.options.floatingFilter === false
    ) {
      if (
        Number(this.pageSize) !== 5 &&
        Number(this.pageSize) !== 10 &&
        Number(this.pageSize) !== 20 &&
        Number(this.pageSize) !== 50 &&
        Number(this.pageSize) !== 100
      ) {
        this.height = 31.3 * Number(this.pageSize) + "px";

        if (this.dropdown !== undefined) {
          let array = [];
          array = this.dropdown.nativeElement.options;

          let obj = this.recordsvalue.filter(
            o => o.value === Number(this.pageSize)
          )[0];
          if (!obj) {
            let value = Number(this.pageSize);
            this.recordsvalue.push({ value: Number(value) });
            this.recordsvalue = new List<SyncValue>(this.recordsvalue)
              .OrderBy(o => o.value)
              .ToArray();

            return (this.dropdown.nativeElement.value = this.recordsvalue.filter(
              o => o.value === Number(this.pageSize)
            )[0]);
          }
        }
      } else {
        if (Number(this.pageSize) === 5) {
          this.height = 40 * Number(this.pageSize) + "px";
          if (this.pagination && this.options.api)
            this.options.api.paginationGoToFirstPage();
        }
        if (Number(this.pageSize) === 10) {
          this.height = 34 * Number(this.pageSize) + "px";
          if (this.pagination && this.options.api)
            this.options.api.paginationGoToFirstPage();
        }
        if (Number(this.pageSize) === 20) {
          this.height = 30.8 * Number(this.pageSize) + "px";
          if (this.pagination && this.options.api)
            this.options.api.paginationGoToFirstPage();
        }
        if (Number(this.pageSize) === 50) {
          this.height = 29.3 * Number(this.pageSize) + "px";
          if (this.pagination && this.options.api)
            this.options.api.paginationGoToFirstPage();
        }
        if (Number(this.pageSize) === 100) {
          this.height = 28.7 * Number(this.pageSize) + "px";
          if (this.pagination && this.options.api)
            this.options.api.paginationGoToFirstPage();
        }
      }
    }
  }

  public options: GridOptions = <GridOptions>{
    singleClickEdit: true,
    stopEditingWhenGridLosesFocus: true,
    suppressTabbing: false,
    rowSelection: "multiple",
    domLayout: "normal",
    suppressLoadingOverlay: false,
    suppressNoRowsOverlay: this.hideNoRecordOverlay,
    suppressRowClickSelection: true,
    context: this,
    enableFilter: this.enableFilter,
    paginationPageSize: Number(this._pagesize),
    floatingFilter: this.filter,
    enableColResize: true,
    enableSorting: this.sort,
    suppressCellSelection: true,
    columnTypes: {
      currency: {
        aggFunc: 'sum',
       // valueFormatter: params => params.value //Math.floor(params.value).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"), 
        // valueParser: function numberParser(params) {

        //   //return Number(params.newValue) > 0 ? Number(params.newValue) : 0;
        //   return Number(params.newValue);
        // },

         

      },
      number: {
        //aggFunc: 'sum',
        // valueFormatter: params => Math.floor(params.value).toString(),
        // valueParser: function numberParser(params) {

        //   return Number(params.newValue) > 0 ? Number(params.newValue) : 0;
        // }


      },

    },


    //this.columnTypes


    //this.columnTypes,



    // suppressColumnVirtualisation: true
  };



  private selColumn = {
    headerName: "",
    field: "selectedCol",
    width: 40,
    editable: false,
    hide: false,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    onCellValueChanged: params => {
      this.selectedRowClick.emit(params.data);
    },
    filter: "false"
  };

  private actionColumn = {
    headerName: "Actions",
    field: "actionid",
    width: 85,
    cellRendererFramework: GridActionsComponent,
    pinned: "left",
    onCellValueChanged: params => {
      this.index = Number(params.node.rowIndex);
    },
    filter: "false"
  };

  @Input()
  RowAdd: boolean = true;
  calculateammount: any;
  addRow() {

    if (this.options.api && this.RowAdd) {

      const node = this.options.api.getSelectedNodes()[0];

      const myindex = node
        ? node.rowIndex
        : this._data
          ? this._data.length - 1
          : -1;
      const rowIndex = node
        ? node.rowIndex
        : this._data
          ? this._data.length - 1
          : 0;
     const rowData = { lineindex: rowIndex + 1 };
      this.calculateammount = rowData
      

       
    


      this.options.api.updateRowData(<RowDataTransaction>{
        add: [rowData],
        addIndex: rowIndex + 1
      });
      // this.data.lineindex > max
      if (this.columns || this.columns.length > 0) {
  
        let fieldObj = this.columns.filter(o => o.focus === true)[0];
        if (fieldObj) {
          this.options.api.setFocusedCell(myindex + 1, fieldObj.field);
          // this.options.api.setFocusedCell(rowIndex + 1, fieldObj.field);
        } else {
          var val = this.columns.filter(
            o =>
              (o.hide === false || o.hide === undefined) && o.editable === true
          )[0];
          if (val) {
            this.options.api.setFocusedCell(myindex + 1, val.field);
          } else {
            var sno = this.columns.filter(o => o.field === "lineindex")[0];
            if (sno) {
              this.options.api.setFocusedCell(myindex + 1, sno.field);
            }
          }
        }
      }

      if (this._data) {

        this._data.splice(rowIndex + 1, 0, rowData);
      } else {
        this._data = [rowData];
      }

      this.generateIndex(rowIndex);
      this.CustomRow();

    } else {

      this.CustomRow();
    }

   

     
  }

 

  onGridReady() {

    // this.options.api;
    this.options.columnApi;
    this.options.api.sizeColumnsToFit();





  }

  deleteRow() {
    if (this.options.api) {
      const nodes = this.options.api.getSelectedNodes();

      if (nodes && nodes.length && nodes.length > 0) {
        this.CustomDeleteRow();
        nodes.forEach(node => {
          if (node) {
            const rowIndex = node.rowIndex;
            this.options.api.updateRowData(<RowDataTransaction>{
              remove: [node.data]
            });

            if (this._data) {
              const index = this._data.indexOf(node.data);

              if (index !== -1) {
                this._data.splice(index, 1);
              }
            }
          }
        });
        this.generateIndex(0);
        this.CustomAfterDeleteRow();
      }
      this.calculateSummaryInternal();
    }
  }

  updateRowData(rowData: any[] | any) {
    if (this.options.api) {
      this.options.api.updateRowData(<RowDataTransaction>{
        update: Array.isArray(rowData) ? rowData : [rowData]
      });
    }
  }

  addRowData(rowData: any[] | any, rowIndex: number = 0) {
    if (this.options.api) {
      this.options.api.updateRowData(<RowDataTransaction>{
        add: Array.isArray(rowData) ? rowData : [rowData],
        addIndex: rowIndex
      });

      this.generateIndex(0);
    }
  }

  generateIndex(startIndex: number) {
    startIndex = 1;
    if (this.options.api) {
      this.options.api.forEachNode(x => {
        x.setDataValue("lineindex", startIndex);
        startIndex++;
      });
    }
  }

  public display(mydata: [any], key: string) {

    setTimeout(() => {
      if (this.options.api) {
        this.options.api.deselectAll();

        if (this.options.api) {
          this.options.api.forEachNode(x => {
            const rowData = x.data;

            var row =
              mydata !== null
                ? mydata.filter(o => o[key] === rowData[key])[0]
                : null;
            if (row) {

              Object.keys(row).map(name => {


                var ctrl = this.columns.filter(
                  o => o.field === name && o.allowClear === true
                )[0];
                if (ctrl) {
                  rowData[name] = undefined;
                }

                if (row[name]) {
                  rowData[name] = row[name];
                }

                if (rowData[name] && row[name] && rowData[name] === row[name]) {
                  x.setSelected(true);
                }
              });
            } else {
              Object.keys(rowData).map(name => {

                var ctrl = this.columns.filter(
                  o => o.field === name && o.allowClear === true
                )[0];

                if (ctrl) {
                  rowData[name] = undefined;
                }
              });
            }

            x.setData(rowData);


            if (this._data) {
              this._data.splice(x.rowIndex, rowData);
            }
          });
        }
      }
      this.calculateSummaryInternal();
    }, 700);

    this.generateIndex(0);
  }

  public displayv2(mydata: [any], keys: string[]) {

    setTimeout(() => {
      if (this.options.api) {
        this.options.api.deselectAll();

        if (this.options.api) {
          this.options.api.forEachNode(x => {
            const rowData = x.data;

            var row = mydata !== null ? mydata.filter(x => keys.every(f => x[f] === rowData[f]))[0] : null;

            if (row) {
              Object.keys(row).map(name => {
                var ctrl = this.columns.filter(
                  o => o.field === name && o.allowClear === true
                )[0];
                if (ctrl) {
                  rowData[name] = undefined;
                }

                if (row[name]) {
                  rowData[name] = row[name];
                }

                if (rowData[name] && row[name] && rowData[name] === row[name]) {
                  x.setSelected(true);
                }
              });
            } else {
              Object.keys(rowData).map(name => {

                var ctrl = this.columns.filter(
                  o => o.field === name && o.allowClear === true
                )[0];

                if (ctrl) {
                  rowData[name] = undefined;
                }
              });
            }

            x.setData(rowData);


            if (this._data) {
              this._data.splice(x.rowIndex, rowData);
            }
          });
        }
      }
      this.calculateSummaryInternal();
    }, 700);

    this.generateIndex(0);
  }

  private selectAll() {
    this.options.api.selectAll();
  }

  private unselectAll() {
    this.options.api.deselectAll();
  }

  async openScreen() {

    this.startLoading();
    this.myscreen.screen.myForm.enable();
    this.index = -1;

    var rowData = null;

    if (this.index !== -1) {
      rowData = this.options.api.getRowNode(this.index.toString()).data;
    }

    this.myscreen.mode = Enum.Mode.New;
    this.actionOpen.emit(<modalArgs>{
      modal: this.myscreen,
      rowData: rowData,
      cancel: false
    });
    if (this.modaltype === 2 && this.modalwidth) {
      if (this.modalwidth !== Enum.modalSize.Large) {
        this.modalwidth = this.modalwidth + "px";
      }
      await this.myscreen.customModalSize(this.modalwidth);
    } else {
      await this.myscreen.open();
    }
    this.myscreen.screen.service.clearCondition();

    await this.myscreen.screen.clear();
    this.stopLoading();
  }

  Open(event: CustomEvent) { }

  Close(event: CustomEvent) {
    const modal: IXSModalComponent = event.detail;

    var data = modal.screen.model;

    var modalArgs: modalArgs = <modalArgs>{
      modal: modal,
      rowData: data,
      cancel: false
    };

    this.actionClose.emit(modalArgs);

    modal.screen.service.clearCondition();

    if (modal.mode === Enum.Mode.New) {
      const rowIndex =
        this.addRowAt === addRow.top ? 0 : this.options.rowData.length + 1;

      this.addRowData(data, rowIndex);

      if (this._data) {
        this._data.splice(rowIndex, 0, data);
      } else {
        this._data = [data];
      }

      this.generateIndex(0);
    } else if (modal.mode === Enum.Mode.Edit) {
      // var rowNode = this.options.api.getRowNode(this.index.toString());
      var rowNode = this.options.api
        .getRenderedNodes()
        .filter(o => o.rowIndex === this.index)[0];

      rowNode.setData(data);

      this.generateIndex(0);
    }

    var rowData = null;

    if (this.index !== -1) {
      rowData = this.options.api.getRowNode(this.index.toString()).data;
    }
  }

  get primeryKeyField(): string {
    let primeryColumn = null;
    if (this.columns && this.columns.length && this.columns.length > 0)
      primeryColumn = this.columns.filter(o => o.isPrimeryKey === true)[0];

    if (!primeryColumn) {
      console.error("Primery Column not defined");
      return null;
    }
    return primeryColumn.field;
  }

  private overlayNoRowsTemplate =
    "<img src='assets/Images/norecordfoundblue.png' style='height: 150px; '></img>";

  startLoading() {
    if (this.toolbarEvent) this.toolbarEvent.boardcast("start");
  }

  stopLoading() {
    if (this.toolbarEvent) this.toolbarEvent.boardcast("stop");
  }

  @Input()
  customButton: any = [];
  customButtonClick(item: customButton) {
    item.customButtons = this.customButton;
    this.toolbarClick.emit(item);
  }

  onRowDragEnd(e) {
    this.data.sort();
  }

  setCount() {
    if (this._data) {
      if (this.options.api) {
        this.options.api.paginationSetPageSize(Number(this._pagesize));
        this.firstpagecount = this.options.api.paginationGetCurrentPage();
        if (this.firstpagecount === 0) {
          this.firstpagecount = 1;
        }
        this.lastpagecount = this.options.api.paginationGetTotalPages();
        if (this.lastpagecount === 0) {
          this.lastpagecount = this.firstpagecount;
        }
      }
    }
  }

  firstpage() {
    if (this.options.api) {
      this.options.api.paginationGoToFirstPage();
      this.firstpagecount = 1;
    }
  }

  previouspage() {
    if (this.firstpagecount === 1) {
      this.firstpagecount = 1;
    } else {
      if (this.options.api) {
        this.options.api.paginationGoToPreviousPage();
        this.firstpagecount--;
      }
    }
  }
  nextpage() {
    if (this.firstpagecount === this.lastpagecount) {
      this.firstpagecount = this.lastpagecount;
    } else {
      if (this.options.api) {
        this.options.api.paginationGoToNextPage();
        this.firstpagecount++;
      }
    }
  }
  lastpage() {
    if (this.options.api) {
      this.options.api.paginationGoToLastPage();
      this.firstpagecount = this.lastpagecount;
    }
  }

  filter_active: Boolean;

  Filtershow() {
    if (this.filter === true) {
      var data = this.options.api.setFilterModel(null);
      this.options.api.onFilterChanged();
      this.options.floatingFilter = !this.options.floatingFilter;
      this.options.api.refreshHeader();
      this.firstpage();
      if (this.options.floatingFilter === true) {
        this.filter_active = true;
      } else {
        this.filter_active = false;
      }
    }
  }

  @Input()
  hideNew: boolean = false;

  @Input()
  hideSave: boolean = false;

  @Input()
  hideSaveClose: boolean = false;

  @Input()
  hideClose: boolean = false;

  @Input()
  hideSelect: boolean = false;

  @Input()
  hideUnSelect: boolean = false;

  @Input()
  showButtonList: boolean = false;

  private groups: any = [];

  private listdata: [moodcustomList];

  private async Groupload() {
    if (this.listdata) {
      this.groups = new List<moodcustomList>(this.listdata)
        .Select(o =>
          o.grpname === "" || o.grpname === null || o.grpname === undefined
            ? "Options"
            : o.grpname
        )
        .Distinct()
        .ToArray();
    }
  }

  @Input()
  set moodcustomList(value: any) {
    this.listdata = value;
    this.Groupload();
  }
  get moodcustomList() {
    return this.listdata;
  }

  filterData(grp): Array<moodcustomList> {
    if (grp === "Options") {
      grp = undefined;
      return this.listdata.filter(o => o.grpname === grp);
    } else {
      return this.listdata.filter(o => o.grpname === grp);
    }
  }

  @Output()
  moodevent: EventEmitter<moodcustomList> = new EventEmitter<moodcustomList>();

  moodclickevent(item: moodcustomList) {
    this.moodevent.emit(item);
  }

  @Input()
  hideRecord: Boolean = true;

  @Input()
  hidetoolbar: Boolean = true;

  Gridmenu: Boolean = false;

  private menudata: [customGridMenu];

  @Input()
  set customGridMenu(value: any) {
    this.menudata = value;
    this.loadData();
    if (this.menudata) {
      this.Gridmenu = true;
    }
  }
  get customGridMenu() {
    return this.menudata;
  }

  @Output()
  gridmenuevent: EventEmitter<customGridMenu> = new EventEmitter<
    customGridMenu
    >();

  onMenuclickevent(item: customGridMenu) {
    this.gridmenuevent.emit(item);
  }

  private gridmenugroup: any = [];

  private async loadData() {
    if (this.menudata) {
      this.gridmenugroup = new List<customGridMenu>(this.menudata)
        .Select(o =>
          o.grpname === "" || o.grpname === null || o.grpname === undefined
            ? "Options"
            : o.grpname
        )
        .Distinct()
        .ToArray();
    }
  }

  filterGridMenu(grp): Array<customGridMenu> {
    if (grp === "Options") {
      grp = undefined;
      return this.menudata.filter(o => o.grpname === grp);
    } else {
      return this.menudata.filter(o => o.grpname === grp);
    }
  }

  @Input()
  ExportCombo: Boolean = false;

  @Input()
  isExport: Boolean = undefined;

  async onRowClickedInner(event) {
    if (event) {
      this.onRowClicked.emit(event);
    }
  }

  // async ColumnsWidth() {
  //   if (this.columns && this.options.columnApi) {
  //     this.columns.forEach(element => {
  //       if (element.field === "lookupcol" ||
  //         element.field === "lineindex" ||
  //         element.field === "selectedCol" ||
  //         element.field === "actionid" ||
  //         element.cellRendererFramework
  //       ) {
  //       }
  //       else {
  //         this.options.columnApi.autoSizeColumn(element.field);
  //       }
  //     });
  //   }
  // }
  filterchanges() {
    this.setCount();
  }

  private _summaryConfig: summaryConfig[];

  @Input()
  enableSummary: boolean;

  @Input()
  get summaryConfig(): summaryConfig[] {
    return this._summaryConfig;
  }
  set summaryConfig(value: summaryConfig[]) {
    if (this.enableSummary) {
      this._summaryConfig = value;
      this.summaryGroupLoad();
    }
  }

  private calculateSummary(params) {
    if (params && params.colDef && params.colDef.allowCalculate) {
      this.calculateSummaryInternal();
    }
  }

  private calculateSummaryInternal() {
    if (this.enableSummary) {
      this.summaryConfig.forEach(element => {
        var filter = undefined;

        if (element.type == Operator.Sum) {
          let val = this.data
            .filter(function (o) {
              if (
                element.filterBy &&
                element.filterBy.field &&
                element.filterBy.value &&
                element.filterBy.Condition
              )
                return element.filterBy.Condition == Condition.Equal
                  ? o[element.filterBy.field] == element.filterBy.value
                  : element.filterBy.Condition == Condition.GreaterThen
                    ? o[element.filterBy.field] > element.filterBy.value
                    : element.filterBy.Condition == Condition.GreaterThenEqual
                      ? o[element.filterBy.field] >= element.filterBy.value
                      : element.filterBy.Condition == Condition.LessThen
                        ? o[element.filterBy.field] < element.filterBy.value
                        : element.filterBy.Condition == Condition.LessThenEqual
                          ? o[element.filterBy.field] <= element.filterBy.value
                          : o[element.filterBy.field] == element.filterBy.value;
              else return element.filterBy ? false : true;
            })
            .reduce(function (previousValue, currentValue) {
              return (
                (previousValue !== undefined ? previousValue : 0) +
                (currentValue[element.field] !== undefined
                  ? Number(currentValue[element.field])
                  : 0)
              );
            }, 0);

          element.value = val;
        } else if (element.type == Operator.Formula) {
          let addVal = 0;
          let subVal = 0;
          if (element.AddFields) {
            element.AddFields.forEach(addField => {
              if (this.summaryConfig.filter(o => o.summaryFieldName == addField.field)[0])
                addVal += this.summaryConfig.filter(
                  o => o.summaryFieldName == addField.field
                )[0].value;
            });
          }
          if (element.SubFields) {
            element.SubFields.forEach(subField => {
              if (this.summaryConfig.filter(o => o.summaryFieldName == subField.field)[0])
                subVal += this.summaryConfig.filter(
                  o => o.summaryFieldName == subField.field
                )[0].value;
            });
          }

          element.value = addVal - subVal;
        } else if (element.type == Operator.Percent) {
          this.calculatePercentage(element);
        } else if (element.type == Operator.Count) {
          let val = this.data.filter(function (o) {
            if (
              element.filterBy &&
              element.filterBy.field &&
              element.filterBy.value &&
              element.filterBy.Condition
            )
              return element.filterBy.Condition == Condition.Equal
                ? o[element.filterBy.field] == element.filterBy.value
                : element.filterBy.Condition == Condition.GreaterThen
                  ? o[element.filterBy.field] > element.filterBy.value
                  : element.filterBy.Condition == Condition.GreaterThenEqual
                    ? o[element.filterBy.field] >= element.filterBy.value
                    : element.filterBy.Condition == Condition.LessThen
                      ? o[element.filterBy.field] < element.filterBy.value
                      : element.filterBy.Condition == Condition.LessThenEqual
                        ? o[element.filterBy.field] <= element.filterBy.value
                        : o[element.filterBy.field] == element.filterBy.value;
            else return element.filterBy ? false : true;
          }).length;

          element.value = val;
        }
      });
      this.afterSummaryValueChange.emit(this.summaryConfig);
    }
  }

  private calculatePercentage(element: summaryConfig) {
    if (this.enableSummary) {
      let percentBase = 0;
      let percent = 0;

      if (
        this.summaryConfig.filter(o => o.summaryFieldName == element.percentBaseField)[0]
      ) {
        percentBase = this.summaryConfig.filter(
          o => o.summaryFieldName == element.percentBaseField
        )[0].value;
        percent = element.value;
      }

      if (
        this.summaryConfig.filter(o => o.summaryFieldName == element.percentValueField)[0]
      ) {
        this.summaryConfig.filter(
          o => o.summaryFieldName == element.percentValueField
        )[0].value = (percentBase * percent) / 100;
      }
    }
  }

  summaryValueChange(item: summaryConfig) {
    this.calculatePercentage(item);
  }
  private summaryGroup;

  private summaryGroupLoad() {
    if (this.summaryConfig) {
      this.summaryGroup = new List<summaryConfig>(this.summaryConfig)

        .Select(o =>
          o.group === "" || o.group === null || o.group === undefined
            ? "Summary"
            : o.group
        )
        .Distinct()
        .ToArray();

    }
  }

  //  filterSummaryGroup(grp): Array<summaryConfig> {
  //  grp = grp == "Summary" ? undefined : grp;

  //    let summaryConfig = this.summaryConfig.filter(o => o.group === grp);



  //   return summaryConfig;
  // }

  toggle() {
    // $("sidebargrid1").toggleClass("active");
    $("#sidebar1").toggleClass("control-sidebar");
  }

  private _opened: boolean = false;
  private _isCollapsed: boolean = false;
  @ViewChild("khulja") AnimateSlideCellRenderer;


  @Input()
  get isCollapsed(): boolean {
    return this._isCollapsed;
  }

  set isCollapsed(value) {
    this._isCollapsed = value;
  }

  private _toggleSidebar(event) {
    if (
      !this.AnimateSlideCellRenderer.nativeElement.classList.contains(
        "control-sidebar-open"
      )
    ) {

      this.AnimateSlideCellRenderer.nativeElement.classList.add("active");
      this.AnimateSlideCellRenderer.nativeElement.classList.add("control-sidebar-open");

      this._opened = true;
    } else {

      this.AnimateSlideCellRenderer.nativeElement.classList.remove("active");
      this.AnimateSlideCellRenderer.nativeElement.classList.remove("control-sidebar-open");

      this._opened = false;

    }
  }

  private get summaryPanelHeight(): string {
    let height;

    height = this.height.replace("px", "");

    return Number(height) - 2 + "px";
  }

  JsonData: any = [];
  exporttype: number = 0;
  btnexport: boolean = false;
  btnimport: boolean = false;
  filename: any;

  typesvalue(event) {
    this.exporttype = 0;
    if (event && event.target.value) {
      this.exporttype = Number(event.target.value);
    }
    if (this.exporttype === 0) {
      this.btnexport = false;
      this.btnimport = false;
    }
    if (this.exporttype === Enum.ExportTypes.Export) {
      this.exporttype = Enum.ExportTypes.Export;
      this.btnexport = true;
      this.btnimport = false;
    }
    if (this.exporttype === Enum.ExportTypes.Import) {
      this.exporttype = Enum.ExportTypes.Import;
      this.btnimport = true;
      this.btnexport = false;

    }
  }

  Export() {
    if (this.data && this.data.length > 0 && this.columns && this.columns.length > 0 && this.options.api) {
      this.JsonData = [];
      this.options.api.forEachNodeAfterFilter((node) => {
        let row = node.data;
        var obj = {};
        this.columns.forEach(col => {
          if (col.field === "lookupcol" ||
            col.field === "selectedCol" ||
            col.field === "actionid" ||
            col.cellEditorFramework === "MoodEditorComponent" ||
            col.hide === true) {
          } else {
            let field = "row." + col.field;

            if (col.dropdownData !== undefined) {
              let val = _.get(row, col.field);
              let c = col.dropdownData.filter(o => o[col.dataValueField] === val)[0];
              if (c) {
                obj[col.headerName] = c[col.dataDisplayField];
              } else {
                obj[col.headerName] = "";
              }
            } else {
              obj[col.headerName] = _.get(row, col.field);
            }
          }
        });
        if (obj) {
          this.JsonData.push(obj);
        }
      });
      if (this.JsonData && this.JsonData.length > 0) {
        this.excel.exportAsExcelFile(this.JsonData, "");
      }
    }
  }

  fileselect() {
    $('#file-input').trigger('click');
    $('#file-input').change(e => {
      this.incomingfile(e);
    });
  }

  arrayBuffer: any;
  file: File;
  incomingfile(file) {
    if (file) {
      this.file = file.currentTarget.files[0];
      this.filename = file.currentTarget.files[0].name;
      if (this.file) {
        this.Upload();
      }
    } else {
      file = undefined;
    }
  }
  Upload() {
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) {
        arr[i] = String.fromCharCode(data[i]);
      }
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true, dateNF: "dd-mmm-yyyy" }));
      this.data = XLSX.utils.sheet_to_json(worksheet, { raw: true, dateNF: "dd-mmm-yyyy" });
    }
    if (this.file) {
      fileReader.readAsArrayBuffer(this.file);
    }
  }

  async editMode(event) {
    if (this.type === GridType.actionsGrid && event && event.node && this.hideActionColumn === false && this.hideActionEdit === false) {
      await this.myscreen.screen.clear();
      var node = this.options.api
        .getRenderedNodes()
        .filter(o => o === event.node)[0];
      if (node && node.data) {
        this.index = node.rowIndex;
        if (this.primeryKeyField) {
          const PrimaryKeyValue = node.data[this.primeryKeyField];
          this.myscreen.mode = Enum.Mode.Edit;
          this.myscreen.screen.service.addDefaultCondition(
            this.primeryKeyField + " = @0",
            [PrimaryKeyValue]
          );
          this.myscreen.displayLastRecord = true;
          //this.Grid.index = this.params.rowIndex;

          var rowData = null;

          if (this.index !== -1) {
            //   rowData = this.Grid.options.api.getRowNode(this.Grid.index.toString())
            //     .data;
            rowData = this.options.api
              .getRenderedNodes()
              .filter(o => o.rowIndex === this.index)[0].data;
          }

          this.actionOpen.emit(<modalArgs>{
            modal: this.myscreen,
            rowData: rowData,
            cancel: false
          });
          this.startLoading();
          if (this.modaltype === 2 && this.modalwidth) {
            if (this.modalwidth !== Enum.modalSize.Large) {
              var tab = document.getElementsByClassName("custom");
              if (tab) {
                $(tab[0].children[0]).css({ width: this.modalwidth });
                $(tab[0].children[0].children[0]).css({ width: this.modalwidth });
                $(tab[0]).css({ top: 0, left: 0, right: 0, bottom: 0, display: 'inline', position: 'fixed' });
              }
            }
            await this.myscreen.open();
            this.stopLoading();
          } else {
            await this.myscreen.open();
            this.stopLoading();
          }
          this.stopLoading();
        }
      }
    }
  }

  @Output()
  CustomAddRow: EventEmitter<any> = new EventEmitter<any>();

  async CustomRow() {
    this.CustomAddRow.emit();
  }

  @Output()
  CustomDeletRow: EventEmitter<any> = new EventEmitter<any>();

  async CustomDeleteRow() {

    this.CustomDeletRow.emit();

  }

  @Output()
  CustomAfterDelete: EventEmitter<any> = new EventEmitter<any>();

  async CustomAfterDeleteRow() {
    this.CustomAfterDelete.emit();
  }

  tabToNextCell(params: TabToNextCellParams) {
    var result = {};
    if (params && params.nextCellDef) {
      if (params.nextCellDef && params.nextCellDef.column && params.nextCellDef.column.getColDef() && params.nextCellDef.column.getColDef().cellRendererFramework && params.nextCellDef.column.getColDef().cellRendererFramework.name === "GridDimensionComponent") {
        if (params.nextCellDef.column['gridApi'])
          params.nextCellDef.column['gridApi'].clearFocusedCell();
        result = {
          rowIndex: params.nextCellDef.rowIndex,
          column: params.nextCellDef.column.getColDef().cellRendererFramework.prototype.setDimentionControlFocused(),
          floating: params.nextCellDef.floating
        };
      }
      else if (params.nextCellDef && params.nextCellDef.column && params.nextCellDef.column.getColDef() && params.nextCellDef.column.getColDef().cellRendererFramework && params.nextCellDef.column.getColDef().cellRendererFramework.name === "GridSelectComponent") {
        if (params.nextCellDef.column['gridApi'])
          params.nextCellDef.column['gridApi'].clearFocusedCell();
        result = {
          rowIndex: params.nextCellDef.rowIndex,
          column: params.nextCellDef.column.getColDef().cellRendererFramework.prototype.setSelectControlFocused(),
          floating: params.nextCellDef.floating
        };
      }
      else if (params.nextCellDef && params.nextCellDef.column && params.nextCellDef.column.getColDef() && params.nextCellDef.column.getColDef().cellRendererFramework && params.nextCellDef.column.getColDef().cellRendererFramework.name === "GridDatePickerComponent") {
        if (params.nextCellDef.column['gridApi'])
          params.nextCellDef.column['gridApi'].clearFocusedCell();
        result = {
          rowIndex: params.nextCellDef.rowIndex,
          column: params.nextCellDef.column.getColDef().cellRendererFramework.prototype.setDateControlFocus(),
          floating: params.nextCellDef.floating
        };
      }
      else if (params.nextCellDef && params.nextCellDef.column && params.nextCellDef.column.getColDef() && params.nextCellDef.column.getColDef().cellRendererFramework && params.nextCellDef.column.getColDef().cellRendererFramework.name === "GridTimePickerComponent") {
        if (params.nextCellDef.column['gridApi'])
          params.nextCellDef.column['gridApi'].clearFocusedCell();
        result = {
          rowIndex: params.nextCellDef.rowIndex,
          column: params.nextCellDef.column.getColDef().cellRendererFramework.prototype.setTimeControlFocus(),
          floating: params.nextCellDef.floating
        };
      }
      else {
        if (params.nextCellDef.column['gridApi'])
          params.nextCellDef.column['gridApi'].setFocusedCell(params.nextCellDef.rowIndex, params.nextCellDef.column.getColDef().field);
        result = {
          rowIndex: params.nextCellDef.rowIndex,
          column: params.nextCellDef.column,
          floating: params.nextCellDef.floating
        };
      }
    }
    return result;
  }

  // NavigateToNextCellParams(params) {
  //   
  //   var result = {};
  //   if (params.nextCellDef) {
  //     
  //     if (params.nextCellDef && params.nextCellDef.column && params.nextCellDef.column.getColDef() && params.nextCellDef.column.getColDef().cellRendererFramework && params.nextCellDef.column.getColDef().cellRendererFramework.name === "GridDimensionComponent") {
  //       
  //       if (params.nextCellDef.column['gridApi'])
  //         params.nextCellDef.column['gridApi'].setFocusedCell(params.nextCellDef.rowIndex, params.nextCellDef.column.getColDef().field);
  //       result = {
  //         rowIndex: params.nextCellDef.rowIndex,
  //         column: params.nextCellDef.column.getColDef().cellRendererFramework.prototype.setDimentionControlFocused(),
  //         floating: params.nextCellDef.floating
  //       };
  //     }
  //     else if (params.nextCellDef && params.nextCellDef.column && params.nextCellDef.column.getColDef() && params.nextCellDef.column.getColDef().cellRendererFramework && params.nextCellDef.column.getColDef().cellRendererFramework.name === "GridSelectComponent") {
  //       
  //       if (params.nextCellDef.column['gridApi'])
  //         params.nextCellDef.column['gridApi'].setFocusedCell(params.nextCellDef.rowIndex, params.nextCellDef.column.getColDef().field);
  //       result = {
  //         rowIndex: params.nextCellDef.rowIndex,
  //         column: params.nextCellDef.column.getColDef().cellRendererFramework.prototype.setSelectControlFocused(),
  //         floating: params.nextCellDef.floating
  //       };
  //     }
  //     else if (params.nextCellDef && params.nextCellDef.column && params.nextCellDef.column.getColDef() && params.nextCellDef.column.getColDef().cellRendererFramework && params.nextCellDef.column.getColDef().cellRendererFramework.name === "GridDatePickerComponent") {
  //       
  //       if (params.nextCellDef.column['gridApi'])
  //         params.nextCellDef.column['gridApi'].setFocusedCell(params.nextCellDef.rowIndex, params.nextCellDef.column.getColDef().field);
  //       result = {
  //         rowIndex: params.nextCellDef.rowIndex,
  //         column: params.nextCellDef.column.getColDef().cellRendererFramework.prototype.setDateControlFocus(),
  //         floating: params.nextCellDef.floating
  //       };
  //     }
  //     else if (params.nextCellDef && params.nextCellDef.column && params.nextCellDef.column.getColDef() && params.nextCellDef.column.getColDef().cellRendererFramework && params.nextCellDef.column.getColDef().cellRendererFramework.name === "GridTimePickerComponent") {
  //       
  //       if (params.nextCellDef.column['gridApi'])
  //         params.nextCellDef.column['gridApi'].setFocusedCell(params.nextCellDef.rowIndex, params.nextCellDef.column.getColDef().field);
  //       result = {
  //         rowIndex: params.nextCellDef.rowIndex,
  //         column: params.nextCellDef.column.getColDef().cellRendererFramework.prototype.setTimeControlFocus(),
  //         floating: params.nextCellDef.floating
  //       };
  //     }
  //     else {
  //       
  //       if (params.nextCellDef.column['gridApi'])
  //         params.nextCellDef.column['gridApi'].setFocusedCell(params.nextCellDef.rowIndex, params.nextCellDef.column.getColDef().field);
  //       result = {
  //         rowIndex: params.nextCellDef.rowIndex,
  //         column: params.nextCellDef.column,
  //         floating: params.nextCellDef.floating
  //       };
  //     }
  //   }
  //   return result;
  // }

  onModelChange(item: customButton) {
    item.oldValue = item.value;
     
  }

  @Output()
  afterSummaryValueChange: EventEmitter<summaryConfig[]> = new EventEmitter<summaryConfig[]>();


  async summaryModal() {

    this._opened = true;
    this.SummaryModal.customOpen("xs");
    this.SummaryGroup();
  }
  mainarr: any = [];
  async SummaryGroup() {

    //grp = grp == "Summary" ? undefined : grp;
    //let summaryConfig = this.summaryConfig.filter(o => o.group === grp);
    this.mainarr = [];
    var all: any = [];

    if (this.summaryConfig && this.summaryConfig.length && this.summaryConfig.length > 0) {
      let arr: any = [];

      this.summaryConfig.forEach(element => {

        arr.push(element);
        all.push(element);

        if (arr.length === 5) {

          this.mainarr.push(arr);
          arr = [];
        }
        else if (this.summaryConfig.length === all.length) {

          this.mainarr.push(arr);
          arr = [];

        }

      });

    }


    return this.mainarr;
  }


  //add row
  generatePinnedBottomData() {

    let result = [];

    this._columns.forEach(item => {

      result[item.colId] = null;


      if (item.type) {
        result[item.field] = null;
        result[item.headerName] = null;
      }



    });
    return this.calculatePinnedBottomData(result);
  }
  calculatePinnedBottomData(target: any) {
    let calculate = this._columns.filter(o => o.type)[0]//this._columns.filter(o => o.type ===  GenEnum.calculationtype.sum);
    if (calculate) {
      let type = calculate.type;
      let col = calculate.field;
      if (col) {
        let columnsWithAggregation = [col]

        if (columnsWithAggregation) {
          columnsWithAggregation.forEach(element => {
            console.log('element', element);

            this.options.api.forEachNodeAfterFilter((rowNode: RowNode) => {

              if (rowNode.data[element] && type[0] === GenEnum.numericformatter.number) {
                if (type[1] === GenEnum.calculationtype.sum) {
                  target[element] += Number(rowNode.data[element].toFixed(2));
                }
                else if (type[1] === GenEnum.calculationtype.subtract) {
                  

                }
                else if (type[1] === GenEnum.calculationtype.multiply) {

                }
                else if (type[1] === GenEnum.calculationtype.divide) {

                }
                else if (type[1] === GenEnum.calculationtype.average) {

                }
              }
              else if (rowNode.data[element] && type[0] === GenEnum.numericformatter.currency) {
                if (type[1] === GenEnum.calculationtype.sum) {
                  target[element] += Number(rowNode.data[element].toFixed(2));
                }
                else if (type[1] === GenEnum.calculationtype.subtract) {
                  

                }
                else if (type[1] === GenEnum.calculationtype.multiply) {

                }
                else if (type[1] === GenEnum.calculationtype.divide) {

                }
                else if (type[1] === GenEnum.calculationtype.average) {

                }
              }
              else {

              }



            });
            if (target[element]) {
              target[element] = `Total: ${target[element].toFixed(2)}`;
            }
          })
        }
      }
      return target;
    }

  }
  calculation() {


    let pinnedBottomData = [];

    setTimeout(() => {
      pinnedBottomData = this.generatePinnedBottomData();


      this.options.api.setPinnedBottomRowData([pinnedBottomData]);
    }, 0)


  }


 

 
}



// WEBPACK FOOTER //
// ./src/app/components/grid/aggrid.component.ts